import React from 'react';
import './project.css';
import ThreeScene from '../profile/threescene';

const projects = [
  {
    id: 1,
    title: 'Human Detection ',
    description: 'In This project if a person exists in image it detects that.',
    date: '2023',
    month: 'January',
    githubLink: 'https://github.com/codewithAkram-ui/Face-detection-with-Flask-react'
  },
  {
    id: 2,
    title: 'Actiq',
    description: 'In this project a user can purchase or sell his antique items.',
    date: '2024',
    month: 'JULY',
    githubLink: 'https://github.com/codewithAkram-ui/app-for-selling-antique-items-using-react-and-firebase-'
  },
  {
    id: 3,
    title: 'Ski.io',
    description: 'In this app user connects with each other on the basis of their talent.',
    date: '2024',
    month: 'september',
    githubLink: 'https://github.com/codewithAkram-ui/social-app'
  },
  {
    id: 4,
    title: 'Augemented reality',
    description: 'In this app user can see the augemented reality of medical plants',
    date: '2024',
    month: 'October',
    githubLink: 'https://github.com/codewithAkram-ui/Augemented-Reality'
  },
  {
    id: 5,
    title: 'Library Management',
    description: 'In this app user can book his book of library',
    date: '2024',
    month: 'january',
    githubLink: 'https://github.com/codewithAkram-ui/library-management'
  }
];

const Project = () => {
  return (
    <div className="projects-container">
      <ThreeScene/>
      {projects.map((project) => (
        <div key={project.id} className="parent">
          <div className="card">
            <div className="content-box">
              <span className="card-title">{project.title}</span>
              <p className="card-content">{project.description}</p>
              <a href={project.githubLink} target="_blank" rel="noopener noreferrer" className="see-more">
                View on GitHub
              </a>
            </div>
            <div className="date-box">
              <span className="month">{project.month}</span>
              <span className="date">{project.date}</span>
              
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default Project;
